function AsideMenu(selector) {
  this.menu = document.querySelector(selector);
  this.menuItems = this.menu.querySelectorAll("& > li");

  this.menuItems.forEach((menuItem) => {
    menuItem.addEventListener("click", (e) => {
      for (let sibling of menuItem.parentNode.children) {
        if (sibling !== menuItem) sibling.classList.remove("opened");
      }
      if (menuItem.querySelector("ul") !== null) {
        menuItem.classList.toggle("opened");
      }
    });
  });
}
